import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { LoginComponent } from '../components/auth/login'
import { RegisterComponent } from '../components/auth/register'
import Page from '../components/layout/Page'
import Container from '../components/layout/Container'
import { ForgotPasswordComponent } from '../components/auth/forgotPassword'
import { ApplicationState } from '../store'
import { Loading } from '../components/data/Loading'
import { useUserLoggedInCheck } from '../hooks/useUserLoggedInCheck'
import { TabContainer, Tab as TabComponent } from '../styles/components/tabs'
import { RouteType } from '../types/routes'
import { getUrlWithSalonGuid } from '../utils/urlParams'

enum Tab {
  Login = 'LOGIN_TAB',
  Register = 'REGISTER_TAB',
  ForgotPassword = 'FORGOT_PASSWORD_TAB'
}

const LoginPage: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<Tab>(Tab.Login)

  const { loading: isUserLoading, isLoggedIn: isUserLoggedIn, userData: storedUserData } = useSelector(
    (state: ApplicationState) => state.user
  )

  const history = useHistory()

  useUserLoggedInCheck()

  useEffect(() => {
    if (isUserLoggedIn && storedUserData) {
      history.push(getUrlWithSalonGuid(RouteType.Profile))
    }
  }, [])

  const mapTabToComponent = () => {
    switch (selectedTab) {
      case Tab.Login:
        return <LoginComponent onForgotPasswordClick={() => setSelectedTab(Tab.ForgotPassword)} />
      case Tab.Register:
        return <RegisterComponent />
      case Tab.ForgotPassword:
        return <ForgotPasswordComponent />
      default:
        return null
    }
  }

  return (
    <Page>
      <Container>
        {isUserLoading && <Loading />}

        {selectedTab !== Tab.ForgotPassword && (
          <>
            <TabContainer>
              <TabComponent active={selectedTab === Tab.Login} onClick={() => setSelectedTab(Tab.Login)}>
                Login
              </TabComponent>
              <TabComponent active={selectedTab === Tab.Register} onClick={() => setSelectedTab(Tab.Register)}>
                Register
              </TabComponent>
            </TabContainer>
          </>
        )}

        {mapTabToComponent()}
      </Container>
    </Page>
  )
}

export default LoginPage
